import styled from '@emotion/styled';
import { spacing } from '$variables/theme';
import COLORS from '$variables/colors';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.small} ${spacing.medium} ${spacing.small} 28px;
  border-bottom: 1px solid ${COLORS.shadow2};
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0.18px;
  color: ${COLORS.shadow6};
`;

export const SubTitle = styled.div`
  font-size: 16px;
  line-height: 28px;
  color: ${COLORS.shadow5};

  margin-top: ${spacing.xxSmall};
`;

export const Content = styled.div`
  padding: 28px;
`;
